import { Button } from "@mui/material";
import { FC } from "react";

// component props interface
interface CustomButtonProps {
  title?: string;
  bgColor?: string;
  textColor?: string;
  width?: string;
  onPress?: any;
  sWidth?:any
}

const CustomButton: FC<CustomButtonProps> = ({
  title,
  bgColor,
  textColor,
  onPress,
  width,
  sWidth
}) => {
  return (
    <Button
      onClick={onPress}
      disableElevation
      disableRipple
      size="medium"
      sx={{
        background: bgColor
          ? bgColor
          : process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
        color: textColor ? textColor : "#fff",
        width: {
          md:width ? width : "50%",
          xs:sWidth ,
        },
        mb: 0.5,
        mt: 0.5,
        borderRadius: 2,
      }}
    >
      {title}
    </Button>
  );
};

export default CustomButton;
